<template>
  <div id="eway-off-web">
    <HeaderBar/>
    <div class="panel-scroll" id="scroller">
      <router-view/>
      <FooterBar/>
    </div>
  </div>
</template>

<script>
import HeaderBar from './components/HeaderBar.vue'
import FooterBar from './components/FooterBar'

export default {
  name: 'Eway-off-web',
  components: {
    HeaderBar,
    FooterBar
  }
}
</script>

<style lang="scss">
  @import "assets/style/base.scss";

  #eway-off-web {
    width: 100%;
    height: 100%;
  }

  /*移动端演示*/
  .mobile{
    width: 100%;
    overflow: hidden;
    #eway-off-web,
    html,
    body {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    .panel-scroll {
      @include mb_panel();
      background: #f7f7f7;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue